var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_239_1",
    "data-name": "Component 239 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49962",
    "data-name": "Group 49962",
    transform: "translate(-13504 -14267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49954",
    "data-name": "Group 49954",
    transform: "translate(-214 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49953",
    "data-name": "Group 49953",
    transform: "translate(13726 14406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93878",
    "data-name": "Path 93878",
    d: "M6.25,4.512c-1.115,0-2.231,0-3.346,0A1.839,1.839,0,0,0,1.156,5.629a2.126,2.126,0,0,0-.151.963Q1,13.14,1,19.688a1.986,1.986,0,0,0,.766,1.731,1.672,1.672,0,0,0,.963.347c.364.013.73.022,1.094.022q8.014,0,16.03,0a2.127,2.127,0,0,0,1.181-.238,1.758,1.758,0,0,0,.937-1.489c.057-2.752.012-5.5.024-8.256,0-.008-.007-.014-.01-.022",
    transform: "translate(-1 -1.55)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93879",
    "data-name": "Path 93879",
    d: "M8.007,12.341c.361.113.762-.287,1.028-.527a8.709,8.709,0,0,1,7.32-2.636c.475.069.627.475.638.9a11.658,11.658,0,0,0,.056,1.3c.04.321.24.7.623.6a1.285,1.285,0,0,0,.472-.263,10.469,10.469,0,0,0,.933-.933c1.043-1.1,2.1-2.2,3.139-3.311.245-.28.607-.592.613-.98-.009-.38-.364-.691-.6-.966-1.157-1.247-2.349-2.463-3.5-3.713C18.4,1.5,17.787.774,17.315,1.069a.963.963,0,0,0-.288.7,7.054,7.054,0,0,1-.139,1.672.8.8,0,0,1-.744.4,8.579,8.579,0,0,0-8.38,6.8c-.1.471-.281,1.452.238,1.7Z",
    transform: "translate(-2.042 -1)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishPlatform);
export default __webpack_public_path__ + "static/media/publish-platform.16d63aab7e72172411cf668957203190.svg";
export { ForwardRef as ReactComponent };